import Jt from 'common/util/jt';

const Jt_B = Jt.base;
const isChinese = true;

export default function(Vue) {

    Vue.filter('dateFormat', function(date) {
        if(!date) {return;}
		date = date + '';
        if(date.length === 10) {
            date = parseInt(date) * 1000;
        } else {
            date = parseInt(date);
        }
        date = new Date(date);
        let dateTime = '';
        let minute = 1000 * 60;
        let hour = minute * 60;
        let day = hour * 24;
        let month = day * 30;
        function pad (num, n) {
	        let len = num.toString().length;
	        while(len < n) {
	            num = '0' + num;
	            len++;
	        }
	        return num;
        }
        function getDateDiff(dateTimeStamp) {
	        let now = new Date().getTime();
	        let diffValue = now - dateTimeStamp;
	        let monthC = diffValue / month;
	        let weekC = diffValue / (7 * day);
	        let dayC = diffValue / day;
	        let hourC = diffValue / hour;
	        let minC = diffValue / minute;
			let result = '刚刚';
			if (diffValue >= 604800000) {
				result = date.getFullYear() + '年' + pad(date.getMonth() + 1, 2)+ '月' +pad(date.getDate(), 2) + '日';
			}
			else if (diffValue >= 86400000 && diffValue < 604800000) {
				result = parseInt(dayC) + '天前';
			}
			else if (diffValue >= 3600000 && diffValue < 86400000) {
				result = parseInt(hourC) + '小时前';
	        }
			else if (diffValue < 3600000) {
				result = parseInt(minC) +  '分钟前';
	        }
	        return result;
	    }
        dateTime = getDateDiff(date);
        return dateTime;
    });

    Vue.filter('dateFormat2', function(date) {
        if(!date) {return;}
        date = date + '';
        if(date.length === 10) {
            date = parseInt(date) * 1000;
        } else {
            date = parseInt(date);
        }
        date = new Date(date);
        let dateTime = '';
        let minute = 1000 * 60;
        let hour = minute * 60;
        let day = hour * 24;
        let month = day * 30;
        function pad (num, n) {
	        let len = num.toString().length;
	        while(len < n) {
	            num = '0' + num;
	            len++;
	        }
	        return num;
        }
        function getDateDiff(dateTimeStamp) {
	        let now = new Date().getTime();
	        let diffValue = now - dateTimeStamp;
	        let monthC = diffValue / month;
	        let weekC = diffValue / (7 * day);
	        let dayC = diffValue / day;
	        let hourC = diffValue / hour;
	        let minC = diffValue / minute;
			let result = isChinese ? '刚刚' : 'recently';
	        if(dayC >= 1) {
	            result = (dateTimeStamp).getFullYear() + '/' + pad(date.getMonth() + 1, 2)+ '/' +pad(date.getDate(), 2);
	        }
	        else if(hourC >= 1) {
				result = parseInt(hourC) + (isChinese ? '小时前' : ` hour${parseInt(hourC) === 1 ? '' : 's'} ago`);
	        }
	        else if(minC >= 5) {
				result = parseInt(minC) + (isChinese ? '分钟前' : ` minute${parseInt(minC) === 1 ? '' : 's'} ago`);
	        }
	        return result;
	    }
        dateTime = getDateDiff(date);
        return dateTime;
    });
}



// WEBPACK FOOTER //
// ./src/common/filter/index.js